export const de = {
	COMMON: 'Gemeinsam',
};
